import {
  createActions,
  asyncInitialState,
  asyncOnRequest,
  asyncOnSuccess,
  asyncOnError,
  asyncSelectors,
} from "./utils";

export const { types, actions } = createActions(
  {
    asyncs: {
      getJobs: (data) => data,
    },
  },
  "jobs"
);

let initialState = asyncInitialState({
  jobs: null,
  errorMessage: "",
  success: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.getJobs:
      return asyncOnRequest(state, action);
    case types.saga.getJobs.success:
      return asyncOnSuccess(state, action, (data, action) => {
        return {
          ...data,
          jobs: action.payload.data,
          errorMessage: "",
        };
      });
    case types.saga.getJobs.failure:
      return asyncOnError(state, action);
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors((state) => state.jobs, {
  errorMessage: (data) => data.errorMessage,
});

const syncSelector = {
  isLoading: (state) => state.jobs.loading,
  jobs: (state) => state.jobs.data.jobs,
};

export const selectors = Object.assign({}, asyncSelector, syncSelector);
